import { AudienceParcoursHub } from '../../../components/parcours/AudienceParcoursHub';
import { PATRIMOINE_COLLECTIVITES } from '../../../config/patrimoine-collectivites';

export default function CollectivitesPatrimoineHubPage() {
  return (
    <AudienceParcoursHub
      audienceId="collectivites"
      segment="patrimoine"
      segmentLabel="Patrimoine"
      items={PATRIMOINE_COLLECTIVITES}
      heroEyebrow="Typologies de bâti public · 8 axes"
      heroHeadline="Patrimoine bâti"
      heroHeadlineAccent="de votre collectivité"
      heroIntro="Écoles, mairies, gymnases, piscines, EHPAD, éclairage public, réseaux de chaleur, logement social : chaque typologie de patrimoine public présente des enjeux techniques, réglementaires et financiers spécifiques. Voici les leviers et financements adaptés à chacune."
      primaryCta={{
        label: 'Diagnostic CEE collectivités',
        href: '/collectivites/diagnostic-cee',
      }}
      secondaryCta={{
        label: 'Toutes les aides',
        href: '/collectivites/aides',
      }}
      bullets={['Sources officielles citées', 'Conforme commande publique', 'Sans engagement']}
      gridEyebrow="8 typologies de patrimoine"
      gridTitle="Quel bâti public souhaitez-vous traiter ?"
      ctaFinalTitle="Quelle stratégie pour votre patrimoine ?"
      ctaFinalDescription="On identifie les leviers techniques (isolation, GTB, EnR&R) et les dispositifs de financement qui s'appliquent à chaque typologie de votre parc bâti."
    />
  );
}
